









































































































































































































































































































































































































































































































































































import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import mixins from 'vue-typed-mixins'

import Process from '@/components/workflow/Process.vue'
import Timer from '@/components/workflow/Timer.tsx'
import Task from '@/components/workflow/Task.tsx'
import Gateway from '@/components/workflow/Gateway.tsx'
import Measures from '@/survey/Measures.vue'
import CounselingQuestions from '@/survey/measures/counselingQuestions/CounselingQuestions.vue'

import AuthorizationMixin from '@/routing/AuthorizationMixin'
import ExclusionGuard from '@/views/exclusion/ExclusionGuard.vue'

import Screening from '@/views/assessments/Pre.vue'
import ScreeningCounseling from '@/views/assessments/PreCounseling.vue'
import Interview from '@/views/assessments/Interview.vue'
import WaitList from '@/views/assessments/Wait.vue'
import Counseling from '@/views/counseling/Counseling.vue'

import IptTreatment from '@/views/treatment/depression/ipt/WholeTreatment.vue'
import CbtTreatment from '@/views/treatment/depression/cbt/Task.vue'
import CrTreatment from '@/views/treatment/ptsd/cr/NewTasks.vue'
import ExpoTreatment from '@/views/treatment/ptsd/expo/Tasks.vue'

import LetterDisplay from '@/components/letters/Display.vue'
import LetterEditor from '@/views/treatment/InTaskLetterEditor.vue'

import Post from '@/views/assessments/Post.vue'
import Fu1 from '@/views/assessments/FU1.vue'
import Fu2 from '@/views/assessments/FU2.vue'
import AssessmentMixin from './assessments/AssessmentMixin'

export default mixins(AuthorizationMixin, AssessmentMixin).extend({
  computed: {
    ...mapGetters('workflow', ['isActive']),
    ...mapGetters(['currentCaseId']),
    item7() {
      const item7 = this.$store.getters['sbqr/findBy']({ case_id: this.currentCaseId })
      if (item7) {
        return item7.item_7
      }
      return false
    }
  },
  components: {
    CbtTreatment,
    CrTreatment,
    ExclusionGuard,
    ExpoTreatment,
    Fu1,
    Fu2,
    Gateway,
    Interview,
    IptTreatment,
    Counseling,
    LetterDisplay,
    LetterEditor,
    Post,
    Process,
    Screening,
    ScreeningCounseling,
    Task,
    Timer,
    WaitList,
    Measures,
    CounselingQuestions,
  },
  methods: {
    ...mapActions('workflow', ['fetch', 'startProcess']),
  },
})
